"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidAmountAndSessionResponseToJSON = exports.PrepaidAmountAndSessionResponseFromJSONTyped = exports.PrepaidAmountAndSessionResponseFromJSON = exports.instanceOfPrepaidAmountAndSessionResponse = void 0;
var runtime_1 = require("../runtime");
var TaxDetails_1 = require("./TaxDetails");
/**
 * Check if a given object implements the PrepaidAmountAndSessionResponse interface.
 */
function instanceOfPrepaidAmountAndSessionResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPrepaidAmountAndSessionResponse = instanceOfPrepaidAmountAndSessionResponse;
function PrepaidAmountAndSessionResponseFromJSON(json) {
    return PrepaidAmountAndSessionResponseFromJSONTyped(json, false);
}
exports.PrepaidAmountAndSessionResponseFromJSON = PrepaidAmountAndSessionResponseFromJSON;
function PrepaidAmountAndSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prepaidMicroAmount': !(0, runtime_1.exists)(json, 'prepaid_micro_amount') ? undefined : json['prepaid_micro_amount'],
        'taxDetails': !(0, runtime_1.exists)(json, 'tax_details') ? undefined : (0, TaxDetails_1.TaxDetailsFromJSON)(json['tax_details']),
        'totalMicroAmount': !(0, runtime_1.exists)(json, 'total_micro_amount') ? undefined : json['total_micro_amount'],
        'rolloverMicroAmount': !(0, runtime_1.exists)(json, 'rollover_micro_amount') ? undefined : json['rollover_micro_amount'],
        'paymentSessionId': !(0, runtime_1.exists)(json, 'payment_session_id') ? undefined : json['payment_session_id'],
    };
}
exports.PrepaidAmountAndSessionResponseFromJSONTyped = PrepaidAmountAndSessionResponseFromJSONTyped;
function PrepaidAmountAndSessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prepaid_micro_amount': value.prepaidMicroAmount,
        'tax_details': (0, TaxDetails_1.TaxDetailsToJSON)(value.taxDetails),
        'total_micro_amount': value.totalMicroAmount,
        'rollover_micro_amount': value.rolloverMicroAmount,
        'payment_session_id': value.paymentSessionId,
    };
}
exports.PrepaidAmountAndSessionResponseToJSON = PrepaidAmountAndSessionResponseToJSON;
